<template>
  <div class="noticias">
    <div v-if="loading" class="card">
      <p class="text-secondary">Cargando...</p>
    </div>
    <template v-else-if="micrositio">
      <div class="card">
        <h2 class="card-title" style="margin-left: 0">
          {{ micrositio.nombre }}
        </h2>
        <p
          v-if="micrositio.descripcion"
          class="text-secondary"
          style="margin: 0"
        >
          {{ micrositio.descripcion }}
        </p>
      </div>
      <div v-if="noticias.length" class="cartelera">
        <router-link
          v-for="(noticia, i) in noticias"
          :key="i"
          :to="'/noticias/mostrar/' + noticia.uuid"
          class="card card-interes"
        >
          <h4 class="card-title">{{ noticia.titulo }}</h4>
          <p>Presione para ver</p>
        </router-link>
      </div>
      <div v-else class="card">
        <p class="text-secondary">
          No hay noticias en este micrositio todavía.
        </p>
      </div>
    </template>
    <div v-else class="card">
      <p class="text-secondary">Micrositio no encontrado.</p>
    </div>
  </div>
</template>
<script>
import { MicrositiosServices } from "../services/MicrositiosServices";
import Swal from "sweetalert2";

export default {
  name: "VerMicrositio",
  data() {
    return {
      micrositio: null,
      noticias: [],
      loading: true,
    };
  },
  created() {
    MicrositiosServices.api
      .find(this.$route.params.id)
      .then((data) => {
        if (data.success) {
          this.micrositio = data.micrositio;
          this.noticias = data.noticias;
        }
      })
      .catch(() => {
        Swal.fire("Error", "No se pudo cargar el micrositio", "error");
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
